import React, {useEffect, useState, Fragment} from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import localization from 'assets/localization/localization';
import {Button} from 'react-bootstrap';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import Images from 'assets/images/imageData';
import DropDownInput from "../../../../components/sales/Input/dropDownInput/dropDownInput";
import ModalPop from "../../../../components/sales/modal/modal";

const PmSoftwarePendingSities = ({
                                     pmSoftwareSitesDetails = [],
                                     pmSoftwareMaintenanceSites,
                                     PMSoftwareDownloadList,
                                     fetchMonth,
                                     maintenanceMonth = [],
                                     getPmSoftwareFilterDropDown,
                                     pmSoftwareFilterResponse = []
                                 }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [listData, setListData] = useState();
    const [pageCount, setPageCount] = useState(0);
    const [isFiled, setIsFiled] = useState(false);
    const [successFull, setSuccessFull] = useState(false);
    const [filterData, setFilterData] = useState(null);
    const [showFilter, setShowFilter] = useState(false);
    const [isRoleId, setIsRoleId] = useState();
    const [openModal, setOpenModal] = useState(false);
    const [monthId, setMonthId] = useState();
    const [yearId, setYearId] = useState();
    const [errorNotFound, setErrorNotFound] = useState(false);

    const openHideModal = () => setOpenModal(false);
    const openDownloadModal = () => setOpenModal(true);

    const headers = [
        'Site Number',
        'Schd. Mnt. Date',
        'Site Type',
        'Client Name',
        'Area Name',
        'City',
        'Assigned To',
        'Status',
        'Actions',
    ];

    useEffect(() => {
        setTimeout(() => {
            setIsLoading(true);
            (async () => {
                const roles = await JSON.parse(localStorage.getItem('roles'))[0].id;
                setIsRoleId(roles);
            })();
            setIsLoading(false);
        }, 0);
    }, []);

    const headerBtns = () => {
        return (
            <div className="Pm-btn pm-btn-align">

                <Fragment>

                    <Button
                        className="btn btn-transparent d-md-inline-block "
                        onClick={() => openDownloadModal()}
                    >
                        {localization.downloadPmList}
                    </Button>
                    {isRoleId !== 9 && (
                        <Fragment>

                            {/*<Button*/}
                            {/*    className="btn btn-primary d-md-inline-block "*/}
                            {/*    onClick={() => openUploadModal()}*/}
                            {/*>*/}
                            {/*    <img src={Images?.ArrowRight} alt=""></img>*/}
                            {/*    {localization.uploadPmList}*/}
                            {/*</Button>*/}
                            <Button
                                onClick={filterToggle}
                                className="filter-hamburger btn btn-transparent"
                            >
                                <img src={Images?.Filter} alt=""></img>
                                {localization.showFilters}
                            </Button>

                        </Fragment>
                    )}
                </Fragment>
            </div>
        );
    };

    const headerBtns1 = () => {
        return (
            <Fragment>
                <Button
                    onClick={filterToggle}
                    className="filter-hamburger btn btn-transparent"
                >
                    <img src={Images?.Filter} alt=""></img>
                    {localization.showFilters}
                </Button>
            </Fragment>
        );
    };

    const filterToggle = () => {
        setShowFilter(!showFilter);
    };

    const applyFilter = async (filterData) => {
        localStorage.setItem("pmSoftwareApprovalList", JSON.stringify(filterData));
        setIsLoading(true);
        setFilterData(filterData);
        await pmSoftwareMaintenanceSites(1, filterData);
        setIsLoading(false);
        filterToggle();
    };

    const onPageChange = async (val) => {
        setIsLoading(true);
        await pmSoftwareMaintenanceSites(val.selected + 1, [4, 5, 7], filterData);
        setIsLoading(false);
    };

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            let filter = JSON.parse(localStorage.getItem('pmSoftwareApprovalList')) ?? null
            await pmSoftwareMaintenanceSites(1, [4, 5, 7], filter)
            await getPmSoftwareFilterDropDown();
            await fetchMonth();
            setIsLoading(false);
        })();
    }, []);

    useEffect(() => {
        const action = [
            {name: 'View Report', link: '/dashboard/pm-software-view-report'},
        ];

        const tableData = [
            'id',
            'site_id',
            'site_no',
            'maintenance_date',
            'site_type',
            'client_name',
            'area_name',
            'city_name',
            'assigned_to',
            'status',
            'status_value'
        ];
        if (pmSoftwareSitesDetails && pmSoftwareSitesDetails.resultSets) {
            const data = pmSoftwareSitesDetails.resultSets.map((element) =>
                Object.assign(
                    {},
                    ...tableData.map((key) => ({[key]: element[key]})),
                    {
                        Action: action,
                    }
                )
            );
            if (data) {
                const newData = data.map(function (obj) {
                    obj['manage_id'] = obj['id'];
                    delete obj['id'];
                    obj['id'] = obj['site_id']; // Assign new key
                    delete obj['site_id']; // Delete old key
                    delete obj['status_value']
                    return obj;
                });

                newData && setListData(newData);
            }
            setPageCount(Math.ceil(pmSoftwareSitesDetails.total / pmSoftwareSitesDetails.per_page));
        }
    }, [pmSoftwareSitesDetails]);

    const downloadPM = async () => {
        if (monthId && yearId) {
            setIsFiled(false);
            setIsLoading(true);
            const res = await PMSoftwareDownloadList(monthId, yearId);
            setIsLoading(false);
            if (res) {
                window.open(res, '_self');
                setOpenModal(false);
                setErrorNotFound(false);
                setSuccessFull(true);
            } else {
                setErrorNotFound(true);
            }
        } else setIsFiled(true);
    };

    return (
        <Layout
            title={localization.pmSities}
            Buttons={isRoleId !== 9 ? headerBtns : headerBtns1}
            className={isFiled ? 'requiredFileds' : ''}
            isLoading={isLoading}
        >
            <TableSection
                data={listData}
                isId={false}
                isMngId={false}
                headers={headers}
                srNo={pmSoftwareSitesDetails?.from}
                onPageChange={onPageChange}
                pageCount={pageCount}
                detailList={pmSoftwareSitesDetails && pmSoftwareSitesDetails.resultSets}
            />

            <ListFilters
                showFilter={showFilter}
                filterToggle={filterToggle}
                applyFilter={(val) => applyFilter(val)}
                statusId={'4,5,7'}
                isRoleId={isRoleId}
                listFilterData={pmSoftwareFilterResponse?.site_type ? pmSoftwareFilterResponse : null}
                pmApprovalList={true}
            />

            <ModalPop
                title={localization.downloadPmList}
                show={openModal}
                handleModalHide={openHideModal}
                keyboard
                backdrop
            >
                <div className={`text-center ${isFiled ? 'requiredFileds' : ''}`}>
                    <DropDownInput
                        label={localization.selectMonth}
                        data={maintenanceMonth?.month}
                        required
                        isStarRequired={true}
                        errorMsg={localization.isRequired}
                        getIdValue={(val) => {
                            setMonthId(val.id);
                        }}
                    />
                    <DropDownInput
                        label={localization.selectYear}
                        data={maintenanceMonth?.year}
                        required
                        isStarRequired={true}
                        errorMsg={localization.isRequired}
                        getIdValue={(val) => {
                            setYearId(val.id);
                        }}
                    />
                    <Button
                        className="btn btn-primary mb-4"
                        onClick={() => {
                            downloadPM();
                        }}
                    >
                        {localization.downloadPmList}{' '}
                        <img src={Images?.ArrowRight} alt=""/>
                    </Button>
                    <label className={`error ${errorNotFound ? 'd-block' : ''}`}>
                        {localization.recordNotFound}
                    </label>
                </div>
            </ModalPop>

            {/*<ModalPop*/}
            {/*    title={localization.uploadPmList}*/}
            {/*    show={uploadModal}*/}
            {/*    handleModalHide={hideUploadModal}*/}
            {/*    keyboard*/}
            {/*    backdrop*/}
            {/*>*/}
            {/*    <div className={`text-center ${isFiled ? 'requiredFileds' : ''}`}>*/}
            {/*        <FileUpload*/}
            {/*            isBase64={true}*/}
            {/*            id="bulk_upload"*/}
            {/*            accept=".csv"*/}
            {/*            onChange={(val) => {*/}
            {/*                setFileUrl(val);*/}
            {/*            }}*/}
            {/*        >*/}
            {/*<span className="btn btn-transparent mb-4">*/}
            {/*  {localization.uploadYourFile}*/}
            {/*</span>*/}
            {/*        </FileUpload>*/}
            {/*        <p>(Upload csv file)</p>*/}
            {/*        <Button className="btn btn-primary mb-4" onClick={() => uploadPM()}>*/}
            {/*            {localization.uploadPmList} <img src={Images?.ArrowRight} alt="" />*/}
            {/*        </Button>*/}
            {/*    </div>*/}
            {/*</ModalPop>*/}
            {/*<ModalPop*/}
            {/*    title={localization.conf}*/}
            {/*    show={successFull}*/}
            {/*    handleModalHide={handleSuccessFull}*/}
            {/*    keyboard*/}
            {/*    backdrop*/}
            {/*>*/}
            {/*    <div className="text-center">*/}
            {/*        <div className="success">*/}
            {/*            <img src={Images?.tick} alt="" />*/}
            {/*        </div>*/}
            {/*        <h5>{localization.downloadedSuccessfully}</h5>*/}
            {/*    </div>*/}
            {/*</ModalPop>*/}

            {/*<ModalPop*/}
            {/*    title={localization.conf}*/}
            {/*    show={uploadedSuccessfully}*/}
            {/*    handleModalHide={() => {*/}
            {/*        setUploadedSuccessfully(false);*/}
            {/*    }}*/}
            {/*    keyboard*/}
            {/*    backdrop*/}
            {/*>*/}
            {/*    <div className="text-center">*/}
            {/*        <div className="success">*/}
            {/*            <img src={Images?.tick} alt="" />*/}
            {/*        </div>*/}
            {/*        <h5>{localization.uploadedSuccessfully}</h5>*/}
            {/*    </div>*/}
            {/*</ModalPop>*/}
        </Layout>
    );
};
export default PmSoftwarePendingSities;
